import PasswordForm from './password-form';

export default PasswordForm;
